
import type { PerformanceMetrics } from '@/types/analytics';
import type { PerformanceCore } from './performanceCore';
import type { PerformanceMetricsStore } from './performanceMetricsStore';

/**
 * Tracks navigation-related performance metrics
 */
export class PerformanceNavigationTracker {
  private core: PerformanceCore;
  private metricsStore: PerformanceMetricsStore;

  constructor(core: PerformanceCore, metricsStore: PerformanceMetricsStore) {
    this.core = core;
    this.metricsStore = metricsStore;
  }
  
  trackNavigationTiming() {
    if (performance && performance.getEntriesByType) {
      try {
        // Use Performance Timeline API or Navigation Timing API depending on browser support
        const navigationEntries = performance.getEntriesByType('navigation');
        
        if (navigationEntries && navigationEntries.length > 0) {
          const navEntry = navigationEntries[0] as PerformanceNavigationTiming;
          
          const metrics: Partial<PerformanceMetrics> = {
            timeToFirstByte: navEntry.responseStart - navEntry.requestStart,
            domContentLoaded: navEntry.domContentLoadedEventEnd - navEntry.fetchStart,
            domInteractive: navEntry.domInteractive - navEntry.fetchStart,
            pageLoadTime: navEntry.loadEventEnd - navEntry.fetchStart,
          };
          
          const fcpEntries = performance.getEntriesByName('first-contentful-paint');
          if (fcpEntries && fcpEntries.length > 0) {
            metrics.firstContentfulPaint = fcpEntries[0].startTime;
          }
          
          // Update metrics in the store
          this.metricsStore.updateMetrics(metrics);
          
          this.core.trackPerformanceEvent({
            category: 'performance',
            action: 'navigation_timing',
            label: 'page_load',
            value: Math.round(navEntry.loadEventEnd - navEntry.fetchStart),
            metadata: {
              domComplete: navEntry.domComplete,
              loadEventEnd: navEntry.loadEventEnd,
              timeToFirstByte: metrics.timeToFirstByte,
              domInteractive: navEntry.domInteractive,
              pageLoad: navEntry.loadEventEnd - navEntry.fetchStart,
              navigationType: navEntry.type
            }
          });
        }
      } catch (error) {
        console.warn('Navigation timing tracking error:', error);
      }
    }
  }
}
